export default __webpack_public_path__ + "battery-with-plug.svg";